import React from 'react';
import styled from 'styled-components';
import { User, Clock } from 'lucide-react';

interface AuditBarProps {
  createdByName?: string;
  createdAt?: string;
  updatedByName?: string;
  updatedAt?: string;
}

const AuditContainer = styled.div`
  background: var(--background-secondary);
  padding: 8px 24px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  border-bottom: 1px solid var(--border-color);
  direction: rtl;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 8px 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const AuditItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-tertiary);
`;

const AuditIcon = styled.span`
  display: flex;
  align-items: center;
  color: var(--text-tertiary);
  opacity: 0.7;
`;

const AuditLabel = styled.span`
  font-weight: 500;
`;

const AuditValue = styled.span`
  color: var(--text-secondary);
`;

const formatDateTime = (dateString?: string): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('he-IL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const AuditBar: React.FC<AuditBarProps> = ({
  createdByName,
  createdAt,
  updatedByName,
  updatedAt
}) => {
  return (
    <AuditContainer>
      <AuditItem>
        <AuditIcon><User size={14} /></AuditIcon>
        <AuditLabel>נוצר על ידי:</AuditLabel>
        <AuditValue>{createdByName || '-'}</AuditValue>
      </AuditItem>
      <AuditItem>
        <AuditIcon><Clock size={14} /></AuditIcon>
        <AuditLabel>בתאריך:</AuditLabel>
        <AuditValue>{formatDateTime(createdAt)}</AuditValue>
      </AuditItem>
      <AuditItem>
        <AuditIcon><User size={14} /></AuditIcon>
        <AuditLabel>עודכן על ידי:</AuditLabel>
        <AuditValue>{updatedByName || '-'}</AuditValue>
      </AuditItem>
      <AuditItem>
        <AuditIcon><Clock size={14} /></AuditIcon>
        <AuditLabel>בתאריך:</AuditLabel>
        <AuditValue>{formatDateTime(updatedAt)}</AuditValue>
      </AuditItem>
    </AuditContainer>
  );
};

export default AuditBar;
